import GOApprovalItem from './GOApprovalItem'

export default GOApprovalItem
